import { ArchiveRestore } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogCancel,
    AlertDialogAction,
} from '@/components/ui/alert-dialog';

export default function AlertDialogReactivateCollaborator({ open, onOpenChange, collaborator, onConfirm, onCancel }) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-[380px] rounded-[20px] p-[24px]">
                <AlertDialogHeader className="items-center space-y-0">
                    <div className="w-[56px] h-[56px] rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-[16px]">
                        <ArchiveRestore className="w-6 h-6 text-brand" />
                    </div>
                    <AlertDialogTitle className="text-center text-[18px] text-foreground mb-[8px]">
                        {t('account:compteExistantArchive')}
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-center text-[14px] text-muted-foreground">
                        {t('account:lUtilisateur')}{' '}
                        <span className="font-semibold text-foreground">
                            {collaborator?.name || collaborator?.email}
                        </span>{' '}
                        {t('account:possedeDejaUnCompteMaisIlEstActuellement')}
                        <br />
                        <br />
                        {t('account:voulezVousReactiverCeCompte')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="flex-col gap-[12px] sm:flex-col mt-[24px]">
                    <AlertDialogAction
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                        }}
                        className="w-full bg-brand hover:bg-brand/90 text-white rounded-[12px] py-[14px] text-[15px] h-auto"
                    >
                        {t('account:reactiverLeCompte')}
                    </AlertDialogAction>
                    <button
                        onClick={onCancel}
                        className="w-full bg-muted hover:bg-border text-foreground rounded-[12px] py-[14px] text-[15px] h-auto mt-0 border-0 font-medium transition-colors"
                    >
                        {t('account:nonMerciPasserAuSuivant')}
                    </button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
